export default [
  { key: 0, value: 'LEARN_MORE', text: 'LEARN MORE' },
  { key: 1, value: 'SHOP_NOW', text: 'SHOP NOW' },
  { key: 2, value: 'GET_OFFER', text: 'GET OFFER' },
  { key: 3, value: 'CONTACT_US', text: 'CONTACT US' },
  { key: 4, value: 'GET_QUOTE', text: 'GET QUOTE' },
];



// WEBPACK FOOTER //
// ./src/components/common/CallToAction.js